import { TimeRecord } from "src/app/entities/timeRecord";

export class CancelRestBreakLocalCopyDto {
    BreakTimeRecord: TimeRecord;
    WorkingTimeRecord: TimeRecord;

    constructor(breakTimeRecord: TimeRecord, workingTimeRecord: TimeRecord) {
        this.BreakTimeRecord = breakTimeRecord;
        this.WorkingTimeRecord = workingTimeRecord;
    }
}
